import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/apiClient";
import { ShieldAlert, X } from "lucide-react";

export function DpaReminderBanner({ companyId }) {
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();
  const key = companyId ? `dpaReminderDismissed:${companyId}` : null;

  useEffect(() => {
    if (!companyId) return;
    setHidden(!!sessionStorage.getItem(key));
    apiClient.get(`/companies/${companyId}/dpa`).then((r) => setStatus(r.data)).catch(() => setStatus(null));
  }, [companyId, key]);

  if (!status || status.accepted || hidden) return null;
  const renew = !!status.outdated_acceptance;
  return (
    <div className="mb-4 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="dpa-reminder-banner" data-renew={renew}>
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="flex-1">
        <span className="font-medium">{renew ? `Neue Version des Auftragsverarbeitungsvertrags (v${status.version})` : "Auftragsverarbeitungsvertrag (AVV) noch nicht angenommen"}</span>
        <span className="text-amber-800"> – {renew ? "Bitte die aktualisierte Fassung erneut annehmen, damit der Datenschutz-Nachweis vollständig bleibt." : "Für die Verarbeitung von Personendaten (Kunden, Mitarbeitende) ist ein AVV nach DSG/DSGVO erforderlich. Die Annahme dauert eine Minute."}</span>
        <button type="button" className="ml-2 underline font-medium" onClick={() => navigate("/settings#section-dpa")} data-testid="dpa-reminder-link">Jetzt ansehen und annehmen</button>
      </div>
      <button type="button" aria-label="Später" className="text-amber-700 hover:text-amber-900" onClick={() => { sessionStorage.setItem(key, "1"); setHidden(true); }} data-testid="dpa-reminder-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
